import { Box, Typography } from "@mui/material";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import InstalledProductsTable from "../components/InstalledProducts/InstalledProductsTable";
import { PaginationModel, QueryOptions } from "../interfaces/pagination";
import { InstalledProduct } from "../interfaces/installedProduct";
import { useAllInstalledProducts } from "../services/installedProducts";
import PageTitle from "../components/PageTitle";

const InstalledProductsPage = () => {
  const [installedProducts, setInstalledProducts] = useState<InstalledProduct[]>([]);
  // const [isLoading, setIsLoading] = useState<boolean>(true);

  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page: 0,
    pageSize: 25,
  });

  const [rowCount, setRowCount] = useState<number>(installedProducts.length);

  const [queryOptions, setQueryOptions] = useState<QueryOptions>({});

  const timeoutRef = useRef<number | null>(null);

  const handleFilterModelChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        setQueryOptions((prev) => {
          if (
            filterModel.quickFilterValues &&
            filterModel.quickFilterValues.length > 0
          ) {
            setPaginationModel((prev) => ({
              ...prev,
              page: 0,
            }));

            const search = filterModel.quickFilterValues.join(" ");
            return { ...prev, search };
          } else {
            const { search, ...others } = prev;
            return others;
          }
        });
      }, 300);
    },
    []
  );

  const handleSortModelChange = useCallback((sortModel: GridSortModel) => {
    setQueryOptions((prev) => {
      if (sortModel.length > 0) {
        setPaginationModel((prev) => ({
          ...prev,
          page: 0,
        }));

        const ordering = `${sortModel[0].sort === "desc" ? "-" : ""}${
          sortModel[0].field
        }`;
        return { ...prev, ordering };
      } else {
        const { ordering, ...others } = prev;
        return others;
      }
    });
  }, []);

  const {
    data: installedProductsData,
    mutate,
    isLoading,
  } = useAllInstalledProducts({
    ...paginationModel,
    ...queryOptions,
  });

  const refreshInstalledProducts = () => {
    mutate();
  }

  useEffect(() => {
    setInstalledProducts(installedProductsData?.results || []);

    setRowCount((prevRowCount) => (installedProductsData ? installedProductsData.count : prevRowCount));
  }, [installedProductsData]);

  return (
    <>
      <PageTitle title="Installed Products"/>
      <Box sx={{}}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <InstalledProductsTable
            installedProducts={installedProducts}
            rowCount={rowCount}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleFilterModelChange={handleFilterModelChange}
            handleSortModelChange={handleSortModelChange}
            isLoading={isLoading}
            refreshInstalledProducts={refreshInstalledProducts}
          />
        )}
      </Box>
    </>
  );
};

export default InstalledProductsPage;
